import * as _ from 'lodash';
import * as hash from 'object-hash';
import { connect, Dispatch } from 'react-redux';
import { AppActionCreators, CenterActionCreators, IApplicationState, ICenterServicesDataResponse } from '@nkr/store/index';
import { EmploymentClassification } from '@nkr/enums/index';
import { IListItem, IServicesData, IUpdateServicesDataRequest } from '@nkr/models/index';
import { Col, ControlLabel, FormControl, FormGroup, Panel, Radio } from 'react-bootstrap';
import { IServicesDataValidation } from './validation';
import { ContentWrapper, FormWrapper } from '../styles';
import { IErrorItem } from '../../error-item';
import { initialServicesData, initialServicesValidationData } from '../initial-data';
import CenterProfileNav from '../edit-nav';
import { profileNavKey } from '../../profile-nav-key';
import { Component, FormEvent } from 'react';
import { Validate } from '../../validate';
import { toast } from 'react-toastify';

interface IProps {
    centerId: number,
    isAdmin: boolean,
    isAdminUser: boolean,
    hasDataChanges: boolean,
    pairWorkupList: IListItem[],
    workupWaitList: IListItem[],
    onTabClick: (href: string) => void,
    onDataChanged: (hasDataChanged: boolean) => void,
    updateErrors: (list: IErrorItem[]) => void
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getData: (centerId: number) => Promise<ICenterServicesDataResponse>,
    updateData: (data: IUpdateServicesDataRequest) => Promise<ICenterServicesDataResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    data: IServicesData,
    validation: IServicesDataValidation,
    hash: string,
    isDirty: boolean,
    isValid: boolean,
    options: IListItem[],
    orderCountMax: IListItem[]
}

class CenterServicesTab extends Component<TProps, IState> {
    readonly state: IState = {
        data: initialServicesData,
        validation: initialServicesValidationData,
        hash: '',
        isDirty: false,
        isValid: true,
        options: [
            { id: 0, description: 'No' },
            { id: 1, description: 'Yes, Volunteer' },
            { id: 2, description: 'Yes, Part-Time' },
            { id: 3, description: 'Yes, Full-Time' },
        ],
        orderCountMax: [
            { id: 1, description: '1' },
            { id: 2, description: '2' },
            { id: 3, description: '3' }
        ]
    }
    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting service data, one moment please...').then(() => {
            this.props.getData(this.props.centerId).then(response => {
                this.setState({
                    data: response.data.results,
                    hash: hash(response.data.results)
                });

                this.props.hideLoading();
            });
        });
    }

    save = () => {
        let { isFamilyVoucherParticipant, hasVoucherRestrictions, performsIncompatibleTransplants, performsDesensitization, performsNonSteroidProtocol, maxPairWorkups,
            minimumNddAge, maximumNddAge, providesDonorInsurance, donorWorkupWait, maxBulkCheekSwabsWithin24Hours, recipientWorkupWait, hasAbPatients, livingDonorFullfillJobAsDonorNav, canUtilizeA2toBPatients } = this.state.data;

        let data: IUpdateServicesDataRequest = {
            id: this.props.centerId,
            isFamilyVoucherParticipant,
            hasVoucherRestrictions,
            performsIncompatibleTransplants,
            performsDesensitization,
            livingDonorFullfillJobAsDonorNav,
            performsNonSteroidProtocol,
            maxBulkCheekSwabsWithin24Hours: maxBulkCheekSwabsWithin24Hours != '' ? parseInt(maxBulkCheekSwabsWithin24Hours) : null,
            maxPairWorkups: maxPairWorkups != '' ? parseInt(maxPairWorkups) : null,
            minimumNddAge: minimumNddAge != '' ? parseInt(minimumNddAge) : null,
            maximumNddAge: maximumNddAge != '' ? parseInt(maximumNddAge) : null,
            providesDonorInsurance,
            donorWorkupWait: donorWorkupWait != '' ? parseInt(donorWorkupWait) : null,
            recipientWorkupWait: recipientWorkupWait != '' ? parseInt(recipientWorkupWait) : null,
            canUtilizeA2toBPatients,
            hasAbPatients
        };

        this.props.showLoading('Saving services data, one moment please...').then(() => {
            this.props.updateData(data).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        data: response.data.results,
                        hash: hash(response.data.results)
                    }, () => {
                        toast.success('Services data updated successfully');

                        this.props.onDataChanged(false);
                    });
                }
            });
        });
    }

    validateBeforeSave = () => {
        let validation = Validate.validateServiceData(this.state.data);
        let isValid = Validate.isServiceDataValid(validation);
        let errorList = Validate.getInvalidServiceDataItems(validation).filter(x => x.show);

        this.setState({
            validation,
            isValid,
            isDirty: true,
        }, () => {
            this.props.updateErrors(errorList);

            if (this.state.isValid) {
                this.save();
            } else {
                window.scrollTo(0, 0);
            }
        });
    }

    handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;
        let data = _.cloneDeep(this.state.data);

        if (name == 'isFamilyVoucherParticipant') {
            data.isFamilyVoucherParticipant = parseInt(value) == 1;
        }

        if (name == 'hasVoucherRestrictions') {
            data.hasVoucherRestrictions = parseInt(value);
        }

        if (name == 'performsIncompatibleTransplants') {
            data.performsIncompatibleTransplants = parseInt(value);
        }

        if (name == 'performsNonSteroidProtocol') {
            data.performsNonSteroidProtocol = parseInt(value);
        }

        if (name == 'performsDesensitization') {
            data.performsDesensitization = parseInt(value);
        }

        if (name == 'recipientWorkupWait') {
            data.recipientWorkupWait = value;
        }

        if (name == 'providesDonorInsurance') {
            data.providesDonorInsurance = parseInt(value);
        }

        if (name == 'minimumNddAge') {
            data.minimumNddAge = value;
        }

        if (name == 'maximumNddAge') {
            data.maximumNddAge = value;
        }

        if (name == 'maxPairWorkups') {
            data.maxPairWorkups = value;
        }

        if (name == 'donorWorkupWait') {
            data.donorWorkupWait = value;
        }

        if (name == 'maxBulkCheekSwabsWithin24Hours') {
            data.maxBulkCheekSwabsWithin24Hours = value;
        }

        if (name == 'hasAbPatients') {
            data.hasAbPatients = parseInt(value);
        }

        if (name == 'canUtilizeA2toBPatients') {
            data.canUtilizeA2toBPatients = parseInt(value);
        }

        if (name == 'livingDonorFullfillJobAsDonorNav') {
            data.livingDonorFullfillJobAsDonorNav = parseInt(value);
        }

        let newHash = hash(data);

        let validation = _.cloneDeep(this.state.validation);
        let isValid = this.state.isValid;

        if (this.props.hasDataChanges) {
            validation = Validate.validateServiceData(this.state.data);
            isValid = Validate.isServiceDataValid(validation);
        }

        let errorList = Validate.getInvalidServiceDataItems(validation).filter(x => x.show);

        this.setState({
            data,
            validation,
            isValid
        }, () => {
            this.props.onDataChanged(newHash != this.state.hash);
            this.props.updateErrors(errorList);
        });
    }

    render = () => {
        const {
            performsIncompatibleTransplants, performsNonSteroidProtocol, performsDesensitization, providesDonorInsurance,
            maxPairWorkups,
            minimumNddAge, maximumNddAge,
            donorWorkupWait, recipientWorkupWait, maxBulkCheekSwabsWithin24Hours,
            hasAbPatients, isFamilyVoucherParticipant, hasVoucherRestrictions,
            livingDonorFullfillJobAsDonorNav,
            canUtilizeA2toBPatients
        } = this.state.data;

        const validation = this.state.validation;

        return (
            <>
                <CenterProfileNav
                    activeKey={profileNavKey.SERVICES}
                    isAdmin={this.props.isAdmin}
                    isAdminUser={this.props.isAdminUser}
                    centerId={this.props.centerId}
                    hasChanges={this.props.hasDataChanges}
                    onTabClick={this.props.onTabClick}
                    onSave={this.validateBeforeSave}
                />

                <ContentWrapper>
                    <div style={{ padding: 0 }}>
                        <Panel>
                            <Panel.Heading>Voucher Participation</Panel.Heading>
                            <Panel.Body>
                                <div className='row'>
                                    <div className='col-xs-12 col-sm-5'>
                                        <FormGroup>
                                            <ControlLabel>
                                                Does your center participate in the voucher program?
                                            </ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <Radio id='isFamilyVoucherParticipantYes' name='isFamilyVoucherParticipant' inline checked={isFamilyVoucherParticipant} value={1} onChange={this.handleFieldChange}>Yes</Radio>
                                                <Radio id='isFamilyVoucherParticipantNo' name='isFamilyVoucherParticipant' inline checked={!isFamilyVoucherParticipant} value={0} onChange={this.handleFieldChange}>No</Radio>
                                            </div>
                                        </FormGroup>
                                    </div>

                                    <div className='col-xs-12 col-sm-7'>
                                        <FormGroup>
                                            <ControlLabel>
                                                Do you restrict standard voucher donors from donating before recipient is cleared for transplant?
                                            </ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <Radio id='isFamilyVoucherParticipantYes' name='hasVoucherRestrictions' inline checked={hasVoucherRestrictions == 1} value={1} onChange={this.handleFieldChange}>Yes</Radio>
                                                <Radio id='isFamilyVoucherParticipantNo' name='hasVoucherRestrictions' inline checked={hasVoucherRestrictions == 0} value={0} onChange={this.handleFieldChange}>No</Radio>
                                                <Radio id='isFamilyVoucherParticipantUnk' name='hasVoucherRestrictions' inline checked={hasVoucherRestrictions == -1} value={-1} onChange={this.handleFieldChange}>Unknown</Radio>
                                            </div>
                                        </FormGroup>
                                    </div>
                                </div>
                            </Panel.Body>
                        </Panel>

                        <Panel>
                            <Panel.Heading>Recipient Services</Panel.Heading>
                            <Panel.Body>
                                <div className='row'>
                                    <div className='col-xs-12 col-sm-5'>
                                        <FormGroup>
                                            <ControlLabel>Blood Type Incompatible Transplants</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <Radio id='performsIncompatibleTransplantsYes' name='performsIncompatibleTransplants' inline checked={performsIncompatibleTransplants == 1} value={1} onChange={this.handleFieldChange}>Yes</Radio>
                                                <Radio id='performsIncompatibleTransplantsNo' name='performsIncompatibleTransplants' inline checked={performsIncompatibleTransplants == 0} value={0} onChange={this.handleFieldChange}>No</Radio>
                                                <Radio id='performsIncompatibleTransplantsUnk' name='performsIncompatibleTransplants' inline checked={performsIncompatibleTransplants == -1} value={-1} onChange={this.handleFieldChange}>Unknown</Radio>
                                            </div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Non-steroidal Protocol Available</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <Radio id='performsNonSteroidProtocolYes' name='performsNonSteroidProtocol' inline checked={performsNonSteroidProtocol == 1} value={1} onChange={this.handleFieldChange}>Yes</Radio>
                                                <Radio id='performsNonSteroidProtocolNo' name='performsNonSteroidProtocol' inline checked={performsNonSteroidProtocol == 0} value={0} onChange={this.handleFieldChange}>No</Radio>
                                                <Radio id='performsNonSteroidProtocolUnk' name='performsNonSteroidProtocol' inline checked={performsNonSteroidProtocol == -1} value={-1} onChange={this.handleFieldChange}>Unknown</Radio>
                                            </div>
                                        </FormGroup>
                                    </div>

                                    <div className='col-xs-12 col-sm-7'>
                                        <FormGroup>
                                            <ControlLabel>Desensitization for Living Donor Transplants</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <Radio id='performsDesensitizationYes' name='performsDesensitization' inline checked={performsDesensitization == 1} value={1} onChange={this.handleFieldChange}>Yes</Radio>
                                                <Radio id='performsDesensitizationNo' name='performsDesensitization' inline checked={performsDesensitization == 0} value={0} onChange={this.handleFieldChange}>No</Radio>
                                                <Radio id='performsDesensitizationUnk' name='performsDesensitization' inline checked={performsDesensitization == -1} value={-1} onChange={this.handleFieldChange}>Unknown</Radio>
                                            </div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Wait time in weeks recipient workup w/ no abnormalities</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <FormControl
                                                    componentClass='select'
                                                    name='recipientWorkupWait'
                                                    style={{ width: 'initial' }}
                                                    value={recipientWorkupWait}
                                                    onChange={this.handleFieldChange}
                                                >
                                                    {this.props.workupWaitList.map(item =>
                                                        <option value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </FormGroup>
                                    </div>
                                </div>
                            </Panel.Body>
                        </Panel>

                        <Panel>
                            <Panel.Heading>Donor Services</Panel.Heading>
                            <Panel.Body>
                                <div className='row'>
                                    <div className='col-xs-12 col-sm-5'>
                                        <FormGroup>
                                            <ControlLabel>Provides Donor Insurance</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <Radio id='providesDonorInsuranceYes' name='providesDonorInsurance' inline checked={providesDonorInsurance == 1} value={1} onChange={this.handleFieldChange}>Yes</Radio>
                                                <Radio id='providesDonorInsuranceNo' name='providesDonorInsurance' inline checked={providesDonorInsurance == 0} value={0} onChange={this.handleFieldChange}>No</Radio>
                                                <Radio id='providesDonorInsuranceUnk' name='providesDonorInsurance' inline checked={providesDonorInsurance == -1} value={-1} onChange={this.handleFieldChange}>Unknown</Radio>
                                            </div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Do you have a living donor fulfilling the job as a donor navigator?</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>

                                                <FormControl
                                                    componentClass='select'
                                                    name='livingDonorFullfillJobAsDonorNav'
                                                    style={{ width: 'initial' }}
                                                    value={livingDonorFullfillJobAsDonorNav}
                                                    onChange={this.handleFieldChange}
                                                >
                                                    <option value={null}>{'- Please Select -'}</option>
                                                    {this.state.options.map(item =>
                                                        <option value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </FormGroup>

                                        <FormGroup validationState={!validation.minimumNddAge ? 'error' : null}>
                                            <ControlLabel>Minimum age your center will workup an NDD</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <FormControl
                                                    name='minimumNddAge'
                                                    style={{ width: 50 }}
                                                    value={minimumNddAge}
                                                    onChange={this.handleFieldChange}
                                                />
                                            </div>
                                        </FormGroup>

                                        <FormGroup validationState={!validation.maximumNddAge ? 'error' : null}>
                                            <ControlLabel>Maximum age your center will workup an NDD</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <FormControl
                                                    name='maximumNddAge'
                                                    style={{ width: 50 }}
                                                    value={maximumNddAge}
                                                    onChange={this.handleFieldChange}
                                                />
                                            </div>
                                        </FormGroup>
                                    </div>

                                    <div className='col-xs-12 col-sm-7'>
                                        <FormGroup>
                                            <ControlLabel>Max paired donors that center will work-up</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <FormControl
                                                    componentClass='select'
                                                    name='maxPairWorkups'
                                                    style={{ width: 'initial' }}
                                                    value={maxPairWorkups}
                                                    onChange={this.handleFieldChange}
                                                >
                                                    <option value={-1}>Unlimited</option>
                                                    {this.props.pairWorkupList.map(item =>
                                                        <option value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Wait time in weeks donor workup w/ no abnormalities</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <FormControl
                                                    componentClass='select'
                                                    name='donorWorkupWait'
                                                    style={{ width: 'initial' }}
                                                    value={donorWorkupWait}
                                                    onChange={this.handleFieldChange}
                                                >
                                                    {this.props.workupWaitList.map(item =>
                                                        <option value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Max number of bulk cheek swap orders within 24-Hours</ControlLabel>
                                            <div style={{ paddingLeft: 10 }}>
                                                <FormControl
                                                    componentClass='select'
                                                    name='maxBulkCheekSwabsWithin24Hours'
                                                    style={{ width: 'initial' }}
                                                    value={maxBulkCheekSwabsWithin24Hours}
                                                    onChange={this.handleFieldChange}
                                                >
                                                    {this.state.orderCountMax.map(item =>
                                                        <option value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </FormGroup>
                                    </div>
                                </div>
                            </Panel.Body>
                        </Panel>
                        <Panel>
                            <Panel.Heading>Blood Type &amp; Waitlist</Panel.Heading>
                            <Panel.Body>
                                <FormGroup>
                                    <ControlLabel>Do you have AB patients on your waitlist?</ControlLabel>
                                    <div style={{ paddingLeft: 10 }}>
                                        <Radio id='hasAbPatientsYes' name='hasAbPatients' inline checked={hasAbPatients == 1} value={1} onChange={this.handleFieldChange}>Yes</Radio>
                                        <Radio id='hasAbPatientsNo' name='hasAbPatients' inline checked={hasAbPatients == 0} value={0} onChange={this.handleFieldChange}>No</Radio>
                                        <Radio id='hasAbPatientsUnk' name='hasAbPatients' inline checked={hasAbPatients == -1} value={-1} onChange={this.handleFieldChange}>Unknown</Radio>
                                    </div>
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Can you take A2 and A2B chain ends and use them for B and/or O patients on your waitlist?</ControlLabel>
                                    <div style={{ paddingLeft: 10 }}>
                                        <Radio id='canUtilizeA2toBPatientsYes' name='canUtilizeA2toBPatients' inline value={1} checked={canUtilizeA2toBPatients == 1} onChange={this.handleFieldChange}>Yes</Radio>{' '}
                                        <Radio id='canUtilizeA2toBPatientsNo' name='canUtilizeA2toBPatients' inline value={0} checked={canUtilizeA2toBPatients == 0} onChange={this.handleFieldChange}>No</Radio>{' '}
                                        <Radio id='canUtilizeA2toBPatientsUnknown' name='canUtilizeA2toBPatients' inline value={-1} checked={canUtilizeA2toBPatients == -1} onChange={this.handleFieldChange}>Unknown</Radio>
                                    </div>
                                </FormGroup>
                            </Panel.Body>
                        </Panel>
                    </div>
                </ContentWrapper>
            </>
        );
    }

}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {}
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getData: (centerId) => {
            return dispatch(CenterActionCreators.getServicesData(centerId));
        },
        updateData: (data) => {
            return dispatch(CenterActionCreators.updateServicesData(data));
        },
    }
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterServicesTab);